@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.chariot.landing.pages.HomePage as _com_chariot_landing_pages_HomePage
import com.chariot.landing.pages.PrivacyPage as _com_chariot_landing_pages_PrivacyPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Umali"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_chariot_landing_pages_HomePage()
        }
        ctx.router.register(
            "/privacy-policy",
        ) { pageCtx -> 
            _com_chariot_landing_pages_PrivacyPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("auto-scroll-container", com.chariot.landing.sections.AutoScrollContainerStyle)
        ctx.theme.registerStyle("button", com.chariot.landing.sections.ButtonStyle)
        ctx.theme.registerStyle("text-input", com.chariot.landing.styles.TextInputStyle)
        ctx.theme.registerStyle("email-button", com.chariot.landing.styles.EmailButtonStyle)
        ctx.theme.registerStyle("showdown", com.chariot.landing.styles.showdownStyle)
        ctx.theme.registerStyle("navigation-item", com.chariot.landing.styles.NavigationItemStyle)
        ctx.theme.registerStyle("logo", com.chariot.landing.styles.LogoStyle)
        ctx.theme.registerStyle("social-link", com.chariot.landing.styles.SocialLinkStyle)
        ctx.theme.registerStyle("main-button", com.chariot.landing.styles.MainButtonStyle)
        ctx.theme.registerStyle("visit-store", com.chariot.landing.styles.VisitStoreStyle)
        ctx.theme.registerKeyframes("scroll-left", com.chariot.landing.sections.ScrollLeftKeyframes)
        ctx.theme.registerKeyframes("scroll-right", com.chariot.landing.sections.ScrollRightKeyframes)
        com.chariot.landing.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.chariot.landing.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
